import {Component, OnInit, ViewChild} from '@angular/core';
import {EmailService} from "../../../services/email.service";
import {AgencyCountyCityList, EmailList} from "../../../NIBINInterface";
import Swal from "sweetalert2";
import {EditSettingsModel, GridComponent, ToolbarItems} from "@syncfusion/ej2-angular-grids";
import { L10n, setCulture } from '@syncfusion/ej2-base';


L10n.load({
  'en_US': {
    grid: {
      Update: 'Save',
    }
  }
});

@Component({
  selector: 'app-view-email-list',
  templateUrl: './view-email-list.component.html',
  styleUrls: ['./view-email-list.component.css'],
  providers: [EmailService]
})
export class ViewEmailListComponent implements OnInit {
  Emails: EmailList[] = []
  constructor(private emailService:EmailService) { }
  @ViewChild('EmailsGrid') public EmailsGrid!: GridComponent;
  public editSettings!: EditSettingsModel;
  public toolbar!: ToolbarItems[];

  ngOnInit(): void {
    setCulture('en_US');


    this.loadEmailList()
    this.editSettings = { allowEditing: true, allowAdding: false, allowDeleting: true, mode: 'Batch' };
    this.toolbar = ['Delete', 'Update', 'Cancel'];
  }

  async loadEmailList(){
    this.Emails = await this.emailService.getEmailList({});
  }


  HandleNewEmailTrigger($event: EmailList) {
    this.Emails = []
    this.loadEmailList()
  }

  EmailBatchSave($event: any) {
    for(let r of $event.batchChanges.addedRecords){

    }

    for(let r of $event.batchChanges.changedRecords){
      this.emailService.updateEmailOnList(r).then(r => {
        this.loadEmailList()
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: "Email Successfully Updated",
          timerProgressBar:true,
          timer:4000
        })
      })
    }

    for(let r of $event.batchChanges.deletedRecords){
      this.emailService.removeEmailToList(r).then(r => {
        this.loadEmailList()
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: "Email Successfully Deleted",
          timerProgressBar:true,
          timer:4000
        })
      })
    }

  }
}
